//CRIANDO ACTION

import { createAction, props } from '@ngrx/store';

//padrão de nomenclatura tudo maiusculo
enum BankActionType {
  //textos para acomparnharmos os estados de load bank
  LOAD_CUSTOM_BANK = '[bank] load bank from api',
  LOAD_CUSTOM_BANK_SUCCESS = '[bank] load bank from api return success',
  LOAD_CUSTOM_BANK_ERROR = '[bank] load bank from api return error',
  SAVE_CUSTOM_BANK = '[bank] save bank from api',
  SAVE_CUSTOM_BANK_SUCCESS = '[bank] edit bank from api return success',
  EDIT_CUSTOM_BANK = '[bank] edit bank from api',
  EDIT_CUSTOM_BANK_SUCCESS = '[bank] edit bank from api return success',
  DELETE_CUSTOM_BANK = '[bank] delete bank from api',
}
export const loadBank = createAction(
  BankActionType.LOAD_CUSTOM_BANK
);
export const loadBankSuccess = createAction(
  BankActionType.LOAD_CUSTOM_BANK_SUCCESS,
  props<{ lista: any[] }>()
);
//vai para o effects
export const saveBank = createAction(
  BankActionType.SAVE_CUSTOM_BANK,
  props<{ bank: any }>()
);
//vai para o reducer
export const saveBankSuccess = createAction(
  BankActionType.SAVE_CUSTOM_BANK_SUCCESS,
  props<{ bank: any }>()
);
//vai para o effects
export const editBank = createAction(
  BankActionType.EDIT_CUSTOM_BANK,
  props<{ bank: any; id: number }>()
);
//vai para o reducer
export const editBankSuccess = createAction(
  BankActionType.EDIT_CUSTOM_BANK_SUCCESS,
  props<{ bank: any }>()
);

export const deleteBank = createAction(
  BankActionType.DELETE_CUSTOM_BANK,
  props<{ id: number }>()
);
